export enum CashFtCommissionTypes {
    DIRECT_SALES = 'Direct Sales',
    MISSED_COMMISIONS = 'Missed Commissions',
};
